document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.znt-carousel');
  const next = document.querySelector('.znt-carousel-next');
  const prev = document.querySelector('.znt-carousel-prev');

  if (!slider || !next || !prev) return;

  let dotsContainer;

  // Get number of slides per view
  const getSlidesPerView = () => {
    const w = window.innerWidth;
    if (w <= 768) return 2; // Mobile
    if (w <= 1024) return 3; // Tablet
    return 5; // Desktop
  };

  // Get width of one slide including gap
  const getSlideWidth = () => {
    const firstSlide = slider.querySelector('.znt-carousel-item');
    if (!firstSlide) return 0;
    const gap = parseFloat(window.getComputedStyle(slider).gap) || 16;
    return firstSlide.offsetWidth + gap;
  };

  // Show/hide next/prev buttons
  const updateButtons = () => {
    const slidesPerView = getSlidesPerView();
    const totalSlides = slider.children.length;

    if (totalSlides <= slidesPerView) {
      next.style.display = 'none';
      prev.style.display = 'none';
    } else {
      next.style.display = 'block';
      prev.style.display = 'block';
    }
  };

  // Create dots
  const updateDots = () => {
    if (dotsContainer) dotsContainer.remove();

    const slidesPerView = getSlidesPerView();
    const totalSlides = slider.children.length;

    if (totalSlides <= slidesPerView) return; // No dots on desktop

    dotsContainer = document.createElement('div');
    dotsContainer.className = 'znt-carousel-dots';
    slider.parentNode.appendChild(dotsContainer);

    const pages = Math.ceil(totalSlides / slidesPerView);

    for (let i = 0; i < pages; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Video gallery page ${i + 1} of ${pages}`);
      if (i === 0) {
        dot.classList.add('active');
        dot.setAttribute('aria-current', 'true');
      }
      dot.addEventListener('click', () => {
        slider.scrollTo({ left: i * getSlideWidth() * slidesPerView, behavior: 'smooth' });
        updateActiveDot(i);
      });
      dotsContainer.appendChild(dot);
    }
  };

  // Set active dot
  const updateActiveDot = (index) => {
    if (!dotsContainer) return;
    const dots = dotsContainer.querySelectorAll('button');
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
      if (i === index) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  };

  // Update dot on scroll
  const updateDotsPosition = () => {
    if (!dotsContainer) return;
    const slidesPerView = getSlidesPerView();
    const totalSlides = slider.children.length;
    const pages = Math.ceil(totalSlides / slidesPerView);

    const scrollLeft = slider.scrollLeft;
    const activeIndex = Math.round(scrollLeft / (getSlideWidth() * slidesPerView));
    updateActiveDot(Math.min(activeIndex, pages - 1));
  };

  // Next/Prev buttons
  next.addEventListener('click', () => {
    slider.scrollBy({ left: getSlideWidth() * getSlidesPerView(), behavior: 'smooth' });
    setTimeout(updateDotsPosition, 200);
  });

  prev.addEventListener('click', () => {
    slider.scrollBy({ left: -getSlideWidth() * getSlidesPerView(), behavior: 'smooth' });
    setTimeout(updateDotsPosition, 200);
  });

  // Initial setup
  updateButtons();
  updateDots();

  // Update on resize
  window.addEventListener('resize', () => {
    updateButtons();
    updateDots();
  });

  // Update dots while scrolling manually
  slider.addEventListener('scroll', updateDotsPosition);
});
